import { useQuery } from "@tanstack/react-query";
import { useUser } from "../contextapi/UserContext";
import { offlineSupabase } from "../utils/offlineSupabaseProxy";
import { queryKeys } from "../utils/queryKeys";

interface AdminAuthState {
  isAdmin: boolean;
  isLoading: boolean;
  error: string | null;
}

export const useAdminAuth = (): AdminAuthState => {
  const { user } = useUser();

  // Shares the same query key as useUserRole — no extra network call if already fetched
  const { data: role, isLoading, error } = useQuery({
    queryKey: queryKeys.user.role(user?.id ?? ''),
    queryFn: async () => {
      const { data: userRole, error: roleError } = await offlineSupabase
        .rpc("get_user_role", { user_id: user!.id });

      if (roleError) throw roleError;

      return userRole ?? "initial";
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isAdmin: role === "admin",
    isLoading,
    error: error instanceof Error ? error.message : null,
  };
};
